<template>
  <BaseModal size="small" status="error">
    <div class="flex justify-center flex-col items-center">
      <div class="border-4 border-vw-red rounded-full h-16 w-16 flex items-center justify-center mb-4">
        <i class="fa-solid fa-trash text-vw-red text-4xl p-4"></i>
      </div>

      <h3 class="text-xl text-vw-red mb-2 futura-bold">{{ $t('Weigeren') }}</h3>
      <p class="my-2 text-vw-gray">{{ $t('Weigeren van deze aanvraag verwijdert de aanvraag direct') }}.</p>
      <button @click="confirm"
         class="cursor-pointer bg-vw-red border-2 border-vw-red text-white px-8 py-2 rounded-md mt-4">{{ $t('Verwijderen') }}</button>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "./BaseModal.vue";
import {
  CLOSE_MODAL, CONFIRM_REJECT_REQUEST_DEPOT_RETURN,
  GET_REQUEST_DEPOT_RETURN, MODAL_RETURN_DELETE_SUCCESS, OPEN_MODAL,
  REQUEST_DEREGISTER_DECLINE,
  REQUEST_DEREGISTERS,
  REQUEST_RETURN_DECLINE
} from "@/constants";

export default {
  name: 'ReturnDelete',
  components: {BaseModal},
  mounted() {
  },
  methods: {
    confirm(){
      this.$store.dispatch(CONFIRM_REJECT_REQUEST_DEPOT_RETURN, {id: this.$store.state.modalStore.data.id, accepted: 0}).then((res)=>{
          this.$store.dispatch(GET_REQUEST_DEPOT_RETURN);
      });
    }
  }
}
</script>
